import { render } from "./PageAdd.vue?vue&type=template&id=2cd961e4"
import script from "./PageAdd.vue?vue&type=script&lang=js"
export * from "./PageAdd.vue?vue&type=script&lang=js"

import "./PageAdd.vue?vue&type=style&index=0&id=2cd961e4&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__